package dev.lingvo.site.state

import dev.lingvo.shared.Role

/** One exact selected-workspace role subject for authority-owned UI and async state. */
internal data class WorkspaceAuthoritySubject(
    val request: WorkspaceRequestKey,
    val role: Role,
)

internal val WorkspaceRequestContext.authoritySubject: WorkspaceAuthoritySubject
    get() = WorkspaceAuthoritySubject(key, role)
